<template>
<div id="allheads">
    <Headers v-if="enable !== false"/>
    <MobileHeader/>
    <SettingsModal v-model="settingsOpen"/>
</div>
</template>

<script>
import MobileHeader from '@/components/Headers/MobileHeader.vue'
import Headers from '@/components/Headers/Headers.vue'
import SettingsModal from '@/components/Settings/SettingsModal.vue'

export default {
    name: 'heads',
    inheritAttrs: false,
    props: {
        enable: {
            type: Boolean,
            default: true
        }
    },
    components: { Headers, MobileHeader, SettingsModal },
    data() {
        return { settingsOpen: false }
    },
    mounted() {
        window.addEventListener('shinai:open-settings', this.openSettings)
    },
    beforeUnmount() {
        window.removeEventListener('shinai:open-settings', this.openSettings)
    },
    methods: {
        openSettings() {
            this.settingsOpen = true
        },
    },
}

</script>

<style scoped>

</style>
